import React from 'react';
import { useForm, ValidationError } from '@formspree/react';


export default function ContactForm() {
  const [state, handleSubmit] = useForm("xvzwkqvl");
  const sectionStyle = {
    backgroundImage: 'url("/images/contactFormBG.jpeg")', // Reference to public folder
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  };
  
  if (state.succeeded) {
      return <div className="contact-form-container"><p>Thanks for reaching out! We'll get back to you soon.</p></div>;
  }

  return (
    <div className="form-section" style={sectionStyle} >
    <div className="contact-form-container">
      <h2>Or leave us your information</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="email">Email Address</label>
          <input id="email" type="email" name="email" placeholder="email@example.com" required />
          <ValidationError prefix="Email" field="email" errors={state.errors} className="error-message" />
        </div>

        <div className="form-group">
          <label htmlFor="message">How can we help with your garden?</label>
          <textarea id="message" name="message" placeholder="Tell us about your project..." required />
          <ValidationError prefix="Message" field="message" errors={state.errors} className="error-message" />
        </div>

        <button type="submit" disabled={state.submitting} className="submit-btn">
          {state.submitting ? 'Sending...' : 'Send Message'}
        </button>
      </form>
    </div>
    </div>
  );
}